export default function createSmlouvaVytvoreniRequest(values, zakaznik) {
  return {
    ...values,
    zakaznik
  };
}
